import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTDancerPayoutAllBoard from "../page/VTDancerPayoutAllBoard";

export default function LandingDancerPayoutBoard({page}) {
    return (
        <>
            <Header headerType="AdminPayoutOnly"/>
            {/*<VTDancerPayoutBoard/>*/}
            <VTDancerPayoutAllBoard/>
            <Footer/>
        </>
    );
}